import React, { useState, useEffect, useRef } from "react";
import IconIOTApp from "../../../icons/icon-iot-app.svg";
import IconMobile from "../../../icons/icon-mobile.svg";
import IconWearables from "../../../icons/icon-wearables.svg";
import IconWeb from "../../../icons/icon-web-platform.svg";
import IconVoice from "../../../icons/icon-voice.svg";
import IconChatbots from "../../../icons/icon-chatbots-platform.svg";
import { SlideInWithScroll } from "../utils/animations/slideInWithScroll";
import { motion } from 'framer-motion';

export default function DesignPlatform(props) {
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const ref = useRef();
  //0.65, 0.60, 0.55, 0.50, 0.45, 0.40,
  const triggerPoints = [0.70, 0.65, 0.6, 0.55, 0.45, 0.35, 0.30, 0.25, 0.10, 0.05];
  const triggers = [[0.84, 0.79], [0.81, 0.76], [0.78, 0.73], [0.75, 0.7], [0.72, 0.67], [0.69, 0.64]];

  const setValues = () => {
    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!ref.current) return;
    //console.log('banner top: ', ref.current.offsetTop);

    props.isLoaded && setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });

  const platforms = [
    {
      icon: <IconWeb />,
      name: "Web"
    }, {
      icon: <IconMobile />,
      name: "Mobile"
    }, {
      icon: <IconVoice />,
      name: "Voice"
    }, {
      icon: <IconChatbots />,
      name: "Chatbots"
    }, {
      icon: <IconWearables />,
      name: "Wearables"
    }, {
      icon: <IconIOTApp />,
      name: "IoT"
    }
  ];
  return (
    <div ref={ref} className="design-platform-section section-gap" onLoad={setValues}>
      <div className="container">
        <div className="row d-flex flex-wrap align-v-center">
          <div className="col">
            <div className="design-platform-content">
              <h4 className="h3">We design for all platforms and interfaces</h4>
            </div>
          </div>
          <div className="col">
            <ul className="design-platform-list">
              {platforms.map((platform, i) => {
                const jsx = <motion.li className="platform-item" key={i}>
                  <div className="item-inner">
                    <div className="grid-icon">
                      <i>{platform.icon}</i>
                    </div>
                    <h6>{platform.name}</h6>
                  </div>
                </motion.li>;

                return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={triggers[i]} key={i} />;
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}